module.exports = "pegasus/assets/tech/medium/3.jpg";